module.exports = __webpack_public_path__ + "static/media/marketo-empty-activity.48b3ec17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/marketo-empty-activity.svg
// module id = VfYs
// module chunks = 89